/**
 * Demo data page flag: on in the develop and staging builds only (deploy.yml), where the backend registers the
 * /demo-data routes (`demoData.enabled`). Off, the page has no route and no menu entry.
 */
export const isDemoDataEnabled = (): boolean => {
  const raw = (import.meta.env.VITE_FEATURE_DEMO_DATA ?? 'false').toString().toLowerCase();
  return raw === 'true' || raw === '1';
};

export const DEMO_DATA_PATH = '/admin/demo-data';
export const DEMO_DATA_ROUTE = 'DemoDataPage';
